import React, {createContext, useState, useCallback, useMemo, useContext} from 'react';
import {siteHealthService} from '../services/siteHealthService';

export const SiteHealthContext = createContext();

export const SiteHealthProvider = props => {
  const [results, setResults] = useState([]);
  const [equipmentData, setEquipmentData] = useState([]);
  const [isLoading, setIsLoading] = useState();
  const [err, setErr] = useState();

  const getSiteHealth = useCallback(async (groupId, statusDateTime) => {
    setIsLoading(true);
    setErr(null);
    const data = await siteHealthService.getSiteHealth(groupId, statusDateTime);
    if (data.status === 'SUCCESS') {
      setResults(data.topLevelEquipment);
    } else {
      setErr(data.errors);
    }
    setIsLoading(false);
    return data;
  }, []);

  const clearSiteHealth = useCallback(() => {
    setResults([]);
  }, []);

  const getEquipmentData = useCallback(async (equipmentId, statusDateTime) => {
    setIsLoading(true);
    setErr(null);
    const data = await siteHealthService.getEquipmentData(equipmentId, statusDateTime);
    if (data.status === 'SUCCESS') {
      setEquipmentData(data.equipmentData[0]);
    } else {
      setErr(data.errors);
    }
    setIsLoading(false);
    return data;
  }, []);

  const clearEquipmentData = useCallback(() => {
    setEquipmentData([]);
  }, []);

  const values = useMemo(
    () => ({
      results,
      equipmentData,
      isLoading,
      err,
      getSiteHealth,
      clearSiteHealth,
      getEquipmentData,
      clearEquipmentData,
      setResults,
      setIsLoading,
      setErr,
    }),
    [
      results,
      equipmentData,
      isLoading,
      err,
      getSiteHealth,
      clearSiteHealth,
      getEquipmentData,
      clearEquipmentData,
    ]
  );

  return <SiteHealthContext.Provider value={values}>{props.children}</SiteHealthContext.Provider>;
};

export const useSiteHealth = () => {
  const context = useContext(SiteHealthContext);

  if (context === undefined) {
    throw new Error('useSiteHealth must be used within a UserProvider component.');
  }

  return context;
};
